<div class="w-full">
  <label
    *ngIf="label"
    [for]="resolvedId"
    class="mb-1.5 block text-sm font-medium text-slate700"
    [ngClass]="labelClass"
  >
    {{ label }}
    <span *ngIf="required" class="text-red600">*</span>
  </label>

  <div
    class="group relative flex w-full items-center overflow-hidden rounded-md bg-white transition-all duration-200"
    [ngClass]="{
      'border-red500': shouldShowAnyError,
      'opacity-70': isDisabled,
    }"
  >
    <span
      *ngIf="!isTextArea"
      class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate500 empty:hidden"
    >
      <ng-content select="[prefix-icon]"></ng-content>
    </span>

    <textarea
      *ngIf="isTextArea"
      [id]="resolvedId"
      [name]="name || null"
      [formControl]="control"
      [appTextCase]="textCase"
      [placeholder]="placeholder"
      [attr.readonly]="readonly ? true : null"
      [attr.aria-invalid]="shouldShowAnyError"
      [attr.autocomplete]="autocomplete || null"
      (paste)="handlePaste($event)"
      (copy)="handleCopy($event)"
      (cut)="handleCopy($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      rows="4"
      class="w-full resize-y px-2 rounded-md bg-slate50 border border-slate-300 placeholder:text-slate-400 focus:outline-none focus:border-indigo700 disabled:cursor-not-allowed"
      [ngClass]="textareaClassMap"
    ></textarea>

    <input
      *ngIf="!isTextArea"
      [id]="resolvedId"
      [name]="name || null"
      [type]="resolvedType"
      [formControl]="control"
      [appTextCase]="textCase"
      [placeholder]="placeholder"
      [attr.min]="type === 'number' && min !== null ? min : null"
      [attr.max]="type === 'number' && max !== null ? max : null"
      [attr.step]="type === 'number' && step !== null ? step : null"
      [attr.pattern]="pattern || null"
      [attr.readonly]="readonly ? true : null"
      [attr.aria-invalid]="shouldShowAnyError"
      [attr.autocomplete]="autocomplete || (type === 'password' ? 'new-password' : null)"
      [attr.spellcheck]="type === 'password' ? false : null"
      (input)="handleInput($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      (paste)="handlePaste($event)"
      (copy)="handleCopy($event)"
      (cut)="handleCopy($event)"
      class="w-full rounded-md bg-slate-50 border border-slate-300 placeholder:text-slate-400 placeholder:opacity-100 focus:outline-none focus:border-indigo-700 disabled:cursor-not-allowed"
      [ngClass]="inputClassMap"
    />

    <!-- <button
      *ngIf="canClear"
      type="button"
      class="absolute right-2.5 inline-flex h-6 w-6 items-center justify-center rounded-full text-slate500 transition hover:bg-slate100 hover:text-slate700 focus:outline-none"
      (click)="clear()"
      aria-label="Clear input"
    >
      <svg viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
        <path
          fill-rule="evenodd"
          d="M4.22 4.22a.75.75 0 011.06 0L10 8.94l4.72-4.72a.75.75 0 111.06 1.06L11.06 10l4.72 4.72a.75.75 0 11-1.06 1.06L10 11.06l-4.72 4.72a.75.75 0 11-1.06-1.06L8.94 10 4.22 5.28a.75.75 0 010-1.06z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button> -->

    <button
      *ngIf="type === 'password'"
      type="button"
      class="absolute inset-y-0 right-2 inline-flex w-8 items-center justify-center rounded-md text-slate500 transition  hover:text-slate700 focus:outline-none"
      (click)="togglePasswordVisibility()"
      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
    >
      <app-icon-reusable
        [icon]="showPassword ? eyeCloseIcon : eyeOpenIcon"
        [size]="adornmentIconSize"
        class="flex justify-center"
      ></app-icon-reusable>
    </button>

    <span
      *ngIf="!isTextArea"
      class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate500"
      [ngClass]="{
        'opacity-0': canClear || type === 'password',
        'opacity-100': !canClear && type !== 'password',
      }"
    >
      <app-icon-reusable
        *ngIf="type === 'email'"
        [icon]="emailIcon"
        [size]="adornmentIconSize"
        class="flex justify-center"
      ></app-icon-reusable>
      <app-icon-reusable
        *ngIf="type !== 'email' && suffixIcon"
        [icon]="suffixIcon"
        [size]="adornmentIconSize"
      ></app-icon-reusable>
      <ng-content *ngIf="type !== 'email'" select="[suffix-icon]"></ng-content>
    </span>
  </div>

  <div class="text-xs mt-1">
    <p *ngIf="shouldShowAnyError" class="text-red600">{{ resolvedErrorMessage }}</p>
  </div>
</div>
